import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import DocumentationSidebar from "../../../../Layout/DocumentationSidebar";
import TopMenu from "../../TopMenu";
import { get } from "../../../../utils/api";
import Unauthorized from "../../../../Components/Unauthorized/Unauthorized";
import { useUser } from "../../../../context/AuthContext";
import TableDocument from "../../TableDocument";
import ApprovalSidebar from "../../../../Layout/ApporvalSidebar";

const EmployeeCommuteDocuments = () => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const { user } = useUser();

  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [selectedFacility, setSelectedFacility] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [url, setUrl] = useState("road");
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [Attachment, setAttachment] = useState("");
  const [fromDate, setFromDate] = useState({
    month: 1,
    year: currentYear,
  });
  const [toDate, setToDate] = useState({
    month: currentDate.getMonth() + 1,
    year: currentYear,
  });

  const handleToggle = (option, url) => {
    setSelectedOption(option);
    setUrl(url);
  };

  let filtersToApply = {};

  const fetchData = async (
    filters = isFiltersApplied ? filtersToApply : {}
  ) => {
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        facilityList: selectedFacility.join(","),
        page,
        limit: 10,
      }).toString();

      const response = await get(
        `/scope3/employeeCommute/documents?${queryParams}&startYear=${fromDate.year}&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${toDate.month}`
      );
      setPage(response.data.currentPage);
      setData(response.data.data);
      setTotalPages(response.data.totalPages);
      const url = new URL(
        response.data.data.find((item) => item?.documents)?.documents
      );
      const fileName = url?.pathname.split("/").pop();
      setAttachment(fileName.split("_")[1]?.replace(/%20/g, " "));
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, url, fromDate, toDate, selectedFacility]);

  const heading = [
    {
      title: "Date",
      key: "createdAt",
    },
    user?.companyAdmin
      ? {
          title: "Facility",
          key: "facilityName",
        }
      : null,
    {
      key: Attachment,
      title: "Attachment",
    },
  ].filter(Boolean);

  const toggleData = [];

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  console.log("first2", selectedFacility);

  return (
    <MainDashboardLayout sidebar={<ApprovalSidebar />}>
      {/* <Unauthorized requiredModule="Documentation"> */}
        <TopMenu
          {...{
            setDrawerFilterOpen: setIsFilterModalOpen,
            selectedMonth,
            setSelectedMonth,
            selectedYear,
            setSelectedYear,
            selectedOption,
            handleToggle,
            filterApplied: isFiltersApplied,
            toggleData: toggleData,
            fromDate,
            setFromDate,
            toDate,
            setToDate,
            selectedFacility,
            setSelectedFacility,
          }}
          heading={"Employee Commute"}
        />
        <TableDocument
          data={data}
          totalPages={totalPages}
          page={page}
          handleChangePage={handleChangePage}
          headers={heading}
          columnWidth={user?.companyAdmin ? "20% 25% 30% 18%" : "20% 30% 18%"}
        />
      {/* </Unauthorized> */}
      {/* {totalPages > 1 && (
        <PaginationBox
          // isShortContent={isShortContent}
          {...{
            totalPages,
            page,
            handleChangePage,
          }}
        />
      )} */}
    </MainDashboardLayout>
  );
};

export default EmployeeCommuteDocuments;
